/**
 * Action types for rabbitmq nodes functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle list of rabbitmq nodes.
 */

// Get rabbitmq nodes constants
export const RABBTIMQ_NODES_REQUEST_GET = 'RABBTIMQ_NODES_REQUEST_GET';
export const RABBTIMQ_NODES_RESPONSE_GET_SUCCESS = 'RABBTIMQ_NODES_RESPONSE_GET_SUCCESS';
export const RABBTIMQ_NODES_RESPONSE_GET_FAIL = 'RABBTIMQ_NODES_RESPONSE_GET_FAIL'
